import postAPI from './postAPI.js'

export default async function postCancelTaskInstance(body) {
    const data = await postAPI('taskinstances/cancel', body);
    return data;
}
